import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RepasswordValidator } from './repassword.validator';

@NgModule({
  declarations: [
    RepasswordValidator,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RepasswordValidator,
  ],
})
export class ValidatorModule { }
